import { UserSwitchOutlined } from '@ant-design/icons';
import { ModalForm, ProFormText } from '@ant-design/pro-components';
import { useMutation } from '@tanstack/react-query';
import { App, Button } from 'antd';
import PropTypes from 'prop-types';
import { updateOrganizationOwner } from '../services/organizations';

const UpdateOrganizationOwnerForm = ({ organization, reload }) => {
  const { message } = App.useApp();
  const { mutateAsync: updateOwner, isPending } = useMutation({
    mutationFn: updateOrganizationOwner,
    onSuccess: () => {
      message.success('租户管理员已设置');
      reload?.();
    },
    onError: () => {
      message.error('租户管理员设置失败，请重试');
    },
  });

  return (
    <ModalForm
      title="设置租户管理员"
      trigger={
        <Button type="link" icon={<UserSwitchOutlined />}>
          设置管理员
        </Button>
      }
      width={480}
      modalProps={{
        destroyOnHidden: true,
        okButtonProps: {
          loading: isPending,
        },
      }}
      onFinish={async (values) => {
        try {
          await updateOwner({
            data: {
              organizationId: organization.id,
              phoneNumber: values.phoneNumber,
            },
          });
          return true;
        } catch {
          return false;
        }
      }}
    >
      <ProFormText
        name="phoneNumber"
        label="手机号"
        placeholder="请输入手机号"
        rules={[
          {
            required: true,
            message: '请输入手机号',
          },
          {
            pattern: /^1\d{10}$/,
            message: '请输入正确的手机号',
          },
        ]}
      />
    </ModalForm>
  );
};

UpdateOrganizationOwnerForm.propTypes = {
  organization: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  reload: PropTypes.func,
};

export default UpdateOrganizationOwnerForm;
